const fullDaysInWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]

exports.fullDaysInWeek = fullDaysInWeek;